import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import './App.css';
import HomeScreen from "./app/screens/home_screen";
import AboutScreen from "./app/screens/about_screen";
import ContactScreen from "./app/screens/contact_screen";
import InnovationScreen from "./app/screens/innovation_screen";
import CareerScreen from "./app/screens/careers_screen";
import CaseStudiesScreen from "./app/screens/case_studies_screen";
import ProductsScreen from "./app/screens/products_screen";
import SolutionsScreen from "./app/screens/solutions_screen";
import WhatsAppButton from "./app/components/whatsapp_icon";
import JobDescriptionScreen from "./app/screens/job_description_screen";
import CaseStudyDetailScreen from "./app/screens/case_study_detail_screen";
import JobApplyFormScreen from "./app/screens/job_apply_form_screen";
import PrivacyPolicy from "./app/screens/privacy_screen";

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomeScreen/>} />
          <Route path="/about" element={<AboutScreen/>} />
          <Route path="/contact" element={<ContactScreen/>} />
          <Route path="/innovation" element={<InnovationScreen/>} />
          <Route path="/career" element={<CareerScreen/>} />
          <Route path="/case-studies" element={<CaseStudiesScreen/>} />
          <Route path="/case-studies/case-study" element={<CaseStudyDetailScreen/>} />
          <Route path="/solutions/products" element={<ProductsScreen/>} />
          <Route path="/solutions" element={<SolutionsScreen/>} />
          <Route path="/job-description/:id" element={<JobDescriptionScreen/>} />
          <Route path="/job-apply-form/:id" element={<JobApplyFormScreen/>} />
          <Route path="/privacy" element={<PrivacyPolicy/>} />
        </Routes>
        <WhatsAppButton />
        <ToastContainer
          autoClose={2500}
        />
      </BrowserRouter>
    </>
  );
}

export default App;
